// Copyright (c) 2022 by Move Closer

import { CanHaveTheme, ThemeRegistry } from '../../composables'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface StepsProps extends CanHaveTheme {
  /**
   * Determines the steps to render.
   */
 steps: Step[]
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface Step {
  /**
   * Detemines the label/text of the current step.
   */
  label?: string
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export enum StepsTheme {
  Default = '',
  Primary = 'primary',
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const stepsThemeClassRegistry: ThemeRegistry<string> = {
  [StepsTheme.Default]: '',
  [StepsTheme.Primary]: '--primary'
}
